// axios请求
import axios from "axios";
import qs from "qs";
import { session } from "./session";
import router from '@/router'


const service = axios.create({
    //baseURL:process.env.BASE_API_NEWSTORE,
    baseURL: "/",
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 100000 // request timeout,
});


// request interceptor
// 全局请求拦截
service.interceptors.request.use(
    config => {
        // do something before request is sent
        //if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        // config.headers['authorization'] = 'bearer ' + getToken()
        //}
        console.log("serviceNewStore------",config);
    //     if(config.method=="post"&&config.url.includes("etLeaseOrderStateList")){
    //         config.headers["Content-Type"] = "text/plain; charset=utf-8";
    //         config.headers["Access-Control-Allow-Origin"] = "*";
    //     }

    //    else 
       if (config.url == "/Data/productBrand.ashx?Action=upload") {
            config.url = config.url + "&login_user_id=" + session.getUserId() + "&villages_id=" + session.getVillageId();
            config.headers["Content-Type"] = "multipart/form-data";
            config.headers["Access-Control-Allow-Origin"] = "*";
        } else if (config.url != "/api/login" && config.url.startsWith("/api/" )) {
            config.headers["X-UserId"] = session.getUserId();
            config.headers["X-VillageId"] = session.getVillageId();

        }else if (config.url.startsWith("/8004/")){
            config.headers["Content-Type"] = "application/json";
            config.headers["x-userid"] = session.getUserId();
            config.headers["x-villageid"] = session.getVillageId();
        }
        // 上传换请求头
        else if (config.url.startsWith("/Data/")) {
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
            config.url = config.url + "&login_user_id=" + session.getUserId() + "&villages_id=" + session.getVillageId();
            config.headers["Access-Control-Allow-Origin"] = "*";
            config.data = qs.stringify(config.data);
            // config.headers["Access-Control-Allow-Credentials"] = true;
        }
        console.log(config);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        if (res.code == 101 && res.message == "登陆用户的公司信息有误！") {
            alert(res.message);
            // alert('登录失效');
            router.push({ name: "Login" });
        } else {
            // alert('登录失效');
            return res;
        }


        // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 20000) {
        //   Message({
        //     message: res.message || 'Error',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })

        //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //     // to re-login
        //     MessageBox.confirm(
        //       'You have been logged out, you can cancel to stay on this page, or log in again',
        //       'Confirm logout',
        //       {
        //         confirmButtonText: 'Re-Login',
        //         cancelButtonText: 'Cancel',
        //         type: 'warning'
        //       }
        //     ).then(() => {
        //       store.dispatch('user/resetToken').then(() => {
        //         location.reload()
        //       })
        //     })
        //   }
        //   return Promise.reject(new Error(res.message || 'Error'))
        // } else {
        //   return res
        // }
    },
    error => {
        console.log(error); // for debug
        // Message({
        //   message: error.message,
        //   type: "error",
        //   duration: 5 * 1000,
        // });
        return Promise.reject(error);
    }
);
export const getNewStore = (url, params) => service.get(url, { params });

export const postNewStore = (url, data) => service.post(url, data);
export const postQueryNewStore = (url, params) => service.request({url:url,method:"post",params});

// export const put = (url, data) => service.put(url, data);

// export const del = url => service.delete(url);

export default service;


// WEBPACK FOOTER //
// ./src/utils/serviceNewStore.js